import NoVisitAfterFirstVisitModule from "./NoVisitAfterFirstVisitModule";
import NoVisitAfterFirstVisitSaga from "./redux/noVisitAfterFirstVisitSagas";
import NoVisitAfterFirstVisitReducer from "./redux/noVisitAfterFirstVisitReducer";

export default {
  Component: NoVisitAfterFirstVisitModule,
  moduleName: "noVisitAfterFirstVisit",
  saga: NoVisitAfterFirstVisitSaga(),
  reducer: NoVisitAfterFirstVisitReducer
};
